import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fd8664c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = { class: "cnk" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "price" }
const _hoisted_7 = {
  key: 0,
  class: "col-auto d-flex align-items-center flex-row"
}
const _hoisted_8 = { class: "current-price fw-600 pe-2" }
const _hoisted_9 = { class: "old-price text-decoration-line-through" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "discount" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "icons" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemIcons = _resolveComponent("ItemIcons")!

  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _ctx.product.main_image_url,
            alt: _ctx.product.product.product_info.name,
            style: {"width":"50px","height":"50px"}
          }, null, 8, _hoisted_1)
        ])
      ]),
      _createElementVNode("td", _hoisted_2, [
        _createVNode(_component_ItemIcons, {
          product: _ctx.product.product
        }, null, 8, ["product"])
      ]),
      _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.product.product.product_info.cnk_code), 1),
      _createElementVNode("td", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.product.product.product_info.name), 1)
      ]),
      _createElementVNode("td", _hoisted_6, [
        ((_ctx.product.product.product_price?.discount_percentage ?? 0 > 0) || (_ctx.product.product.product_price?.discount_value_with_vat ?? 0 > 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, " € " + _toDisplayString(_ctx.product.product.product_price.sale_price_with_vat), 1),
              _createElementVNode("div", _hoisted_9, " € " + _toDisplayString(_ctx.product.product.product_price.standard_price_with_vat), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, " € " + _toDisplayString(_ctx.product.product.product_price.sale_price_with_vat), 1))
      ]),
      _createElementVNode("td", _hoisted_11, [
        _createElementVNode("div", {
          innerHTML: _ctx.product.product.discount?.label?.content ?? ''
        }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("td", _hoisted_13, [
        _createElementVNode("button", {
          class: "btn btn-icon btn-sm btn-danger",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteSelection && _ctx.deleteSelection(...args)))
        }, _hoisted_15)
      ])
    ])
  ]))
}